import React from 'react';

const createMarkup = (email: any) => ({
  __html: email
});

const DisplayPreview: React.FC<any> = ({ email }: any) => {
  return <div dangerouslySetInnerHTML={createMarkup(email.body)} />;
};
DisplayPreview.displayName = 'DisplayPreview';
export default DisplayPreview;
